/**
 * @desc 分页-我申请的
 */
const URL = "/rantion-app-center";
import http, { updateResponse } from "@/http";
export type Response = defs.appCenter.ResponseDto<
  defs.appCenter.IPage<defs.appCenter.BizPermissionApplyResponseDto>
>;
export function request(
  params: API.appCenter.bizPermissionApply.pageByApplicant.Params,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/bizPermissionApply/page/applicant`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
